export default __webpack_public_path__ + "static/media/infoDefault.0570f6f0.jpg";